import {
  Alert,
  Button,
  Card,
  Col,
  message,
  Space,
  Row,
  Table,
  Typography,
} from 'antd';
import { useGetTaxDealsListQuery } from '../../apis/lodgeReturnAPI';
import { formatDate } from '@/utils/commonUtils';
import { useEffect, useState } from 'react';
import useScrollToTop from '@/hooks/useScrollTop';
import TableTitle from '@/components/Elements/Heading/TableTitle';
import ApplicationSubHeading from '@/components/Elements/Heading/ApplicationSubHeading';
import { useAppSelector } from '@/hooks/hooks';
import { useResendRegisterEmailMutation } from '@/store/apis/authApi';

const SettledPage = () => {
  const { data: dealsData, isLoading: dealsLoading } = useGetTaxDealsListQuery(
    undefined,
    {
      refetchOnMountOrArgChange: true,
    },
  );

  const [dealData, setDealData] = useState<any>([]);
  const [emailNotVerified, setEmailNotVerified] = useState(false);

  useScrollToTop();

  const [resendRegisterEmail, { isLoading: isResending }] =
    useResendRegisterEmailMutation();

  const handleRequestReview = () => {
    message.loading('Sending verification email...');
    resendRegisterEmail({ email: userData?.email || '' });
  };

  useEffect(() => {
    if (dealsData) {
      const tempData = dealsData.data.filter(
        (item: any) => item.deal_stage_name === 'Completed and Sent',
      );
      setDealData(tempData);
    }
  }, [dealsData]);

  const columns: any = [
    {
      title: <TableTitle>S.N</TableTitle>,
      key: 'index',
      align: 'center',
      render: (_: any, __: any, index: number) => (
        <Typography.Text strong>{index + 1}</Typography.Text>
      ),
    },
    {
      title: <TableTitle>Application ID</TableTitle>,
      dataIndex: 'hs_object_id',
      key: 'hs_object_id',
      align: 'center',
      render: (text: string) => (
        <Typography.Text>{text || 'N/A'}</Typography.Text>
      ),
    },
    {
      title: <TableTitle>Deal Name</TableTitle>,
      dataIndex: 'dealname',
      key: 'dealname',
      align: 'center',
      render: (text: string) => (
        <Typography.Text>{text || 'N/A'}</Typography.Text>
      ),
    },
    {
      title: <TableTitle>Loan Type</TableTitle>,
      dataIndex: 'loan_type',
      key: 'loan_type',
      align: 'center',
      render: (text: string) => (
        <Typography.Text>{text || 'N/A'}</Typography.Text>
      ),
    },
    {
      title: <TableTitle>Request Date</TableTitle>,
      dataIndex: 'createdate',
      key: 'createdate',
      align: 'center',
      render: (_: any, { createdate }: { createdate: string | null }) =>
        createdate ? (
          <Typography.Text>{formatDate(createdate)}</Typography.Text>
        ) : (
          <Typography.Text>N/A</Typography.Text>
        ),
    },
    {
      title: <TableTitle>Action</TableTitle>,
      dataIndex: 'action',
      key: 'action',
      align: 'center',
      render: () => (
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            gap: 8,
          }}
        >
          <Button
            type="primary"
            size="small"
            onClick={() => handleRequestReview()}
          >
            Request Review
          </Button>
        </div>
      ),
    },
  ];

  const { userData } = useAppSelector((state) => state.auth);

  const handleSendVerification = () => {
    message.loading('Sending verification email...');
    resendRegisterEmail({ email: userData?.email || '' });
  };

  return (
    <>
      {emailNotVerified && (
        <Alert
          banner
          message={
            <Space>
              <Typography.Text>
                Your email is not verified. Please verify it to access
                pre-approval HubSpot data.
              </Typography.Text>
              <Button
                type="link"
                style={{
                  cursor: 'pointer',
                  color: '#1890ff',
                  textDecoration: 'underline',
                  fontSize: 14,
                  fontWeight: 'bold',
                }}
                onClick={handleSendVerification}
                loading={isResending}
              >
                Send Verification Email
              </Button>
            </Space>
          }
          type="warning"
          showIcon
          style={{ marginBottom: 16 }}
        />
      )}
      <ApplicationSubHeading title="Settled Applications" />
      <Row>
        <Col xs={24} md={24}>
          <Card title="Settled Applications">
            <Table
              dataSource={dealData}
              columns={columns}
              rowKey="id"
              loading={dealsLoading}
              pagination={{ pageSize: 5 }}
            />
          </Card>
        </Col>
      </Row>
    </>
  );
};

export default SettledPage;
